function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import filter from 'lodash/filter';
import get from 'lodash/get';
import pick from 'lodash/pick';
import isNaN from 'lodash/isNaN';
import times from 'lodash/times';
import valuesIn from 'lodash/valuesIn';
import { useAction } from 'hooks';
import Validator from 'libs/Validator';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../../../../actions';
import * as constants from '../../../../constants';
import * as selectors from '../../../../selectors';
import messages from '../../../../messages';
import styles from '../../DownloadDataModal.pcss';
import validatorRules from './validatorRules.json';
const Actions = ({ values, pinFields })=>{
    const isInProgress = useSelector(selectors.isSendBluetoothPinInProgress);
    const codeValues = pick(values, pinFields);
    const filteredValues = filter(valuesIn(codeValues), (value)=>value !== '');
    const isDisabled = filteredValues.length !== constants.BLUETOOTH_PIN_LENGTH;
    return /*#__PURE__*/ _jsx("div", {
        className: "modal__actions",
        children: /*#__PURE__*/ _jsx(Button, {
            type: "submit",
            styleModifier: "primary",
            labelMessage: messages.buttons.submitPin,
            className: "btn--block btn--filled",
            isDisabled: isDisabled,
            isInProgress: isInProgress
        })
    });
};
const Digit = ({ position, values, inputs, pinFields })=>{
    const setFormValue = useAction(App.actions.setFormValue, constants.BLUETOOTH_PIN_FORM);
    const id = `pin_${position}`;
    const value = get(values, id, '');
    inputs[position] = useRef();
    pinFields[position] = id;
    const onChange = (evt)=>{
        const { value: newValue } = evt.target;
        if (newValue === '') {
            setFormValue({
                id,
                value: newValue
            });
            return;
        }
        const numberValue = Number(newValue);
        if (isNaN(numberValue)) {
            return;
        }
        setFormValue({
            id,
            value: numberValue
        });
        const nextInput = get(inputs, position + 1);
        if (nextInput) {
            nextInput.current.focus();
        }
    };
    return /*#__PURE__*/ _jsx("input", {
        id: id,
        value: value,
        className: `form-control ${styles.pin__digit}`,
        autoComplete: "off",
        autoFocus: !position,
        maxLength: 1,
        onChange: onChange,
        ref: inputs[position]
    }, id);
};
const BluetoothPin = ({ onSetComponent })=>{
    const connectionId = useSelector(selectors.connectionId);
    const formValues = useSelector(App.selectors.formSelector(constants.BLUETOOTH_PIN_FORM));
    const values = get(formValues, [
        'values'
    ], {});
    const isInProgress = useSelector(selectors.isSendBluetoothPinInProgress);
    const prevIsInProgressRef = useRef(isInProgress);
    const hasErrors = useSelector(selectors.hasSendBluetoothPinErrors);
    const inputs = [];
    const pinFields = [];
    const sendBluetoothPin = useAction(actions.sendBluetoothPin);
    const startCheckingConnection = useAction(actions.startCheckingConnection);
    const startFormProcessing = useAction(App.actions.startFormProcessing, constants.BLUETOOTH_PIN_FORM);
    const setFormErrors = useAction(App.actions.setFormErrors, constants.BLUETOOTH_PIN_FORM);
    const clearForm = useAction(App.actions.clearForm, constants.BLUETOOTH_PIN_FORM);
    useEffect(()=>()=>{
            clearForm();
        }, []);
    useEffect(()=>{
        if (prevIsInProgressRef.current !== isInProgress) {
            if (!isInProgress && !hasErrors) {
                startCheckingConnection(connectionId);
                onSetComponent('Downloading');
            }
            prevIsInProgressRef.current = isInProgress;
        }
    }, [
        isInProgress
    ]);
    const onSubmit = ()=>{
        startFormProcessing();
        let pin = '';
        for(let i = 0; i < constants.BLUETOOTH_PIN_LENGTH; i++){
            const id = `pin_${i}`;
            const value = get(values, id);
            pin += value;
        }
        const { validatedValues, errors } = Validator.run(_object_spread_props(_object_spread({}, values), {
            pin
        }), validatorRules);
        if (errors) {
            setFormErrors(errors);
            return;
        }
        sendBluetoothPin(validatedValues);
    };
    const onChangeDeviceType = ()=>{
        onSetComponent('ChooseConnection');
    };
    const renderDigit = (position)=>/*#__PURE__*/ _jsx(Digit, {
            position: position,
            values: values,
            inputs: inputs,
            pinFields: pinFields
        }, position);
    return /*#__PURE__*/ _jsxs("div", {
        className: `${styles.modal__content} h-auto`,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.bluetoothPin.header))
            }),
            /*#__PURE__*/ _jsx("img", {
                src: "/assets/svg/bluetooth-pin.svg",
                className: "mt-4 mb-3",
                alt: ""
            }),
            /*#__PURE__*/ _jsxs(Form, {
                onSubmit: onSubmit,
                className: styles.pinForm,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                className: "form-label",
                                htmlFor: "pin_0",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.pin))
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.pin,
                                children: times(constants.BLUETOOTH_PIN_LENGTH, renderDigit)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Actions, {
                        values: values,
                        pinFields: pinFields
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.divider,
                children: /*#__PURE__*/ _jsx("span", {
                    className: styles.divider__text,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.or))
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "transparent",
                labelMessage: messages.buttons.changeDeviceType,
                className: "btn--no-size text--primary m-0",
                onClick: onChangeDeviceType
            })
        ]
    });
};
export default BluetoothPin;
